import { Vec2 } from "utils/math/vec2";
import { maxCanvasSize, Webgl2dRenderer } from "../../../webgl2d-renderer";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";
import { CanvasResizeSelectionComponent } from "./canvas-resize-selection-component";
import { CanvasResizeUnitComponent } from "./canvas-resize-unit-component";

export class CanvasResizeSelectionBottomLeftComponent extends Webgl2Component {
  private _oppositeVertexPosition = Vec2.zero();
  private _mouseDownPosition = Vec2.zero();
  private _prevTransform: Webgl2Component["transform"];

  constructor(
    private readonly _renderer: Webgl2dRenderer,
    private readonly _canvasResizeSelectionComponent: CanvasResizeSelectionComponent,
  ) {
    super();

    const topUnit = new CanvasResizeUnitComponent(new Vec2(18, 4));
    topUnit.style.top = "100%";
    topUnit.style.translateY = "-100%";
    topUnit.style.pointerEvents = "none";
    this.appendChild(topUnit);

    const leftUnit = new CanvasResizeUnitComponent(new Vec2(4, 18));
    leftUnit.style.pointerEvents = "none";
    this.appendChild(leftUnit);

    this.transform.setSize(18, 18);
  }

  public onMouseDown(e: MouseEvent | TouchEvent) {
    this._oppositeVertexPosition = Webgl2dRenderer.global.getComponentClipSpaceInGlobal(
      this._canvasResizeSelectionComponent,
      Vec2.oneZero(),
    );
    this._mouseDownPosition = this._renderer.camera.getGlobalMousePixelPosition(e);
    this._prevTransform = this._canvasResizeSelectionComponent.transform.clone();
  }

  public onMouseMove(e: MouseEvent | TouchEvent) {
    const currentMousePos = this._renderer.camera.getGlobalMousePixelPosition(e);
    const mouseDiff = currentMousePos.clone().sub(this._mouseDownPosition);
    const newSize = this._prevTransform.size.clone().sub(mouseDiff.x, -mouseDiff.y);

    const newTranslation = this._prevTransform.translation.clone().addX(mouseDiff.x);
    newTranslation.clampX(
      this._oppositeVertexPosition.x - maxCanvasSize,
      this._oppositeVertexPosition.x,
    );
    newTranslation.clampY(
      this._oppositeVertexPosition.y - maxCanvasSize,
      this._oppositeVertexPosition.y,
    );

    this._renderer.setCanvasTranslate(newTranslation);
    this._renderer.setCanvasSize(newSize);
    this._canvasResizeSelectionComponent.copyComponentTransform(this._renderer.chessGridComponent);
    this._renderer.render();
  }

  public getRenderData() {
    const material = Webgl2.materials.transparent;
    return { material };
  }
}

export default CanvasResizeSelectionBottomLeftComponent;
